/* eslint-disable */

/**
 * The web client is requesting that mobile client configure the
 * buttons and title present in the toolbar of the webview.
 * Should be sent from the web to mobile.
 */
export interface TaxWebBridgeConfigureToolbarEventRequest {
  /**
   * The list of items wanting to be displayed. Before this request is received,
   * the mobile clients should default to [{ type: ToolbarItemType.BACK }, { type: ToolbarItemType.MENU }].
   */
  items?: TaxWebBridgeConfigureToolbarEventRequestToolbarItem[];
  /**
   * When passed the contents of the string will be displayed in the toolbar
   * where relevant on each platform. If not passed, no title should be presented.
   */
  title?: string;
}

export enum TaxWebBridgeConfigureToolbarEventRequestToolbarItemType {
  BACK = "BACK",
  HELP = "HELP",
  MENU = "MENU",
  CLOSE = "CLOSE",
  DESKTOP = "DESKTOP",
}

export interface TaxWebBridgeConfigureToolbarEventRequestToolbarItem {
  type?: TaxWebBridgeConfigureToolbarEventRequestToolbarItemType;
}

/**
 * A response for `TaxWebBridgeConfigureToolbarEventRequest` containing a list
 * of IDs that the client currently knows about to help the web with backwards
 * compatibility.
 * Should be sent from mobile to web.
 */
export interface TaxWebBridgeConfigureToolbarEventResponse {
  /** The complete list of item types that the mobile client currently supports. */
  supported_item_types?: TaxWebBridgeConfigureToolbarEventRequestToolbarItemType[];
}
